import advisorhq from "apis/advisorhq";
import * as notifications from "notifications.js";
import * as moment from "moment";
import { hideModal, showModal } from "../modals";
import { LOADING_MODAL } from "../../components/modals";

const reportConfigs = {
  caseSubmission: {
    url: "/life_settlement/api/case_submission_report/",
    filenamePrefix: "Case Submission Report",
  },
  leads: {
    url: "/life_settlement/api/leads_report/",
    filenamePrefix: "Leads Report",
  },
  outgoingCalls: {
    url: "/life_settlement/api/outgoing_calls_report/",
    filenamePrefix: "Outgoing Calls Report",
  },
  outboundEmails: {
    url: "/life_settlement/api/outbound_emails_report/",
    filenamePrefix: "Outbound Emails Report",
  },
};

const downloadReport = async (url, values, filename) => {
  const response = await advisorhq.get(url, {
    params: values,
    responseType: "blob",
  });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(new Blob([response.data]));
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
};

export const downloadReportByKey = (key, values) => async dispatch => {
  const config = reportConfigs[key];

  if (!config) {
    notifications.error(`Unknown report key: ${key}`);
    return;
  }

  dispatch(showModal(LOADING_MODAL, { message: "Downloading report..." }));

  try {
    const filename = _format_filename_date_range(config, values.date_from, values.date_to);
    await downloadReport(config.url, values, filename);
  } catch (e) {
    notifications.error("Error downloading report");
  }

  dispatch(hideModal(LOADING_MODAL));
};

const _format_filename_date_range = (config, date_from, date_to) => {
  // If both dates are present
  let dateRangeLabel = "";

  if (date_from && date_to) {
    const from = moment(date_from);
    const to = moment(date_to);

    if (from.year() === to.year()) {
      if (from.month() === to.month()) {
        console.log(from.day(), to.day());
        if (from.day() === to.day()) {
          // Same day: April 11
          dateRangeLabel = `${from.format("MMMM D")}, ${to.format("YYYY")}`;
        } else {
          // Same month and year: April 11–18
          dateRangeLabel = `${from.format("MMMM D")}-${to.format("D")}, ${to.format("YYYY")}`;
        }
      } else {
        // Same year, different months: March 11–April 11, 2025
        dateRangeLabel = `${from.format("MMMM D")}-${to.format("MMMM D")}, ${to.format("YYYY")}`;
      }
    } else {
      // Different years: December 12, 2024–April 11, 2025
      dateRangeLabel = `${from.format("MMMM D, YYYY")}-${to.format("MMMM D, YYYY")}`;
    }
  } else if (date_from || date_to) {
    // Only one date present, fallback
    const singleDate = moment(date_from || date_to);
    dateRangeLabel = singleDate.format("MMMM D, YYYY");
  }

  return `${config.filenamePrefix}${dateRangeLabel ? ` ${dateRangeLabel}` : ""}.xlsx`;
};
